import React, { Component } from 'react'
import cn from 'classnames'
import EditableField from '@ui/EditableField'

const SIZES = {
  h1: {
    title: 'big',
    subtitle: 'small'
  },
  h3: {
    title: 'normal',
    subtitle: 'extra-small'
  }
}

class Section extends Component {
  handleChangeTitle = title => {
    const { onChange } = this.props
    if (onChange) onChange({ title })
  }

  handleChangeDescription = description => {
    const { onChange } = this.props
    if (onChange) onChange({ description })
  }

  handleBlurTitle = title => {
    const { onBlur } = this.props
    if (onBlur) onBlur({ title, description: this.props.description })
  }

  handleBlurDescription = description => {
    const { onBlur } = this.props
    if (onBlur) onBlur({ title: this.props.title, description })
  }

  render() {
    const {
      children,
      size,
      className,
      editable,
      title,
      description,
      titlePlaceholder,
      descriptionPlaceholder,
      titleTranslationTooltip,
      descriptionTranslationTooltip,
      titleRequired,
      descriptionRequired,
      hideDescription,
      horizontal,
      mode
    } = this.props
    return (
      <div className={cn('section-component', className, mode, { horizontal })}>
        <div className='section-component-header'>
          {(title || editable) && (
            <EditableField
              text={title}
              placeholder={titlePlaceholder}
              onChange={this.handleChangeTitle}
              className={cn('section-component-title', mode)}
              editable={editable}
              size={SIZES[size].title}
              onBlur={this.handleBlurTitle}
              translationTooltip={titleTranslationTooltip}
              required={titleRequired}
              bold
            />
          )}
          {(description || (editable && !hideDescription)) && (
            <EditableField
              text={description}
              placeholder={descriptionPlaceholder}
              onChange={this.handleChangeDescription}
              className={cn('section-component-description', mode)}
              editable={editable}
              size={SIZES[size].subtitle}
              onBlur={this.handleBlurDescription}
              translationTooltip={descriptionTranslationTooltip}
              required={descriptionRequired}
              light
            />
          )}
        </div>
        {children}
      </div>
    )
  }
}

export default Section
